import { DataGrid, DataGridProps } from "@mui/x-data-grid";
import { useCustomTableDataStyles } from "../../TableData/useCustomTableDataStyles";

/**
 * ServerDataGrid
 * Wrapper around MUI DataGrid with server-side pagination
 */
const ServerDataGrid = (props: DataGridProps) => {
	const tableSx = useCustomTableDataStyles();

	return (
		<DataGrid
			{...props}
			pagination
			paginationMode="server"
			sortingMode="server"
			disableColumnFilter
			disableDensitySelector
			disableRowSelectionOnClick
			keepNonExistentRowsSelected
			sx={{
				width: "100%",
				maxWidth: "100%",
				minWidth: "100%",
				"& .MuiDataGrid-main": {
					overflow: "hidden",
				},
				"& .MuiDataGrid-virtualScroller": {
					overflowX: "auto",
				},
				...tableSx,
				...props.sx,
			}}
		/>
	);
};

export default ServerDataGrid;
